const navigation = {
  state: {
    title: 'Grid Monitoring Light',
    rightElements: [],
    backUrl: '/',
    tabs: null,
    class: null,
    color: 'white',
  },
  mutations: {
    SET_NAV_TITLE(state, title) {
      state.title = title;
    },
    SET_NAV_RIGHT_ELEMENTS(state, elements) {
      state.rightElements = elements;
    },
    SET_NAV_BACK_URL(state, backUrl) {
      state.backUrl = backUrl;
    },
    SET_NAV_TABS(state, tabs) {
      state.tabs = tabs;
    },
    SET_NAV_CLASS(state, className) {
      state.class = className;
    },
    SET_NAV_COLOR(state, color) {
      state.color = color;
    },
  },
};

export default navigation;
